<template>
    <section>
        <div class="head" :style="{backgroundColor: backcolor, color: beforecolor, height:(44 + getStatusHeight())+'px'}">
            <div class="status" :style="{height: getStatusHeight()+'px'}"></div>
            <div class="left" @click="returnBackFn"><img v-if="beforecolor === '#000'" class="icon_black" src="@/Images/icon_back.png"/><img v-else class="icon_white" src="@/Images/icon_white_back.png"/></div>
            <div class="nav_title">{{navtitle}}</div>
            <div v-if="getCount(innerPageArticleId) > 0" class="action_left" @click="goInsidePages(innerPageArticleId)">
                <img src="../../assets/action_left.png"/>
                <span>内页</span>
                <div class="clear"></div>
            </div>
            <div v-if="getCount(showRight) > 0" class="action_right" @click="goRight">
                <img src="../../Images/jiangpin.png"/>
                <span>合作</span>
                <div class="clear"></div>
            </div>
            <div class="clear"></div>
            <div v-if="getCount(showNavLine) === 1" class="nav_line"></div>
        </div>
        <div :style="{backgroundColor: backcolor, color: beforecolor, height:(44 + getStatusHeight())+'px'}"></div>
    </section>
</template>

<script>
    export default {
        props: {
            navtitle: {
                type: String,
                default: ''
            },
            beforecolor: {
                type: String,
                default: '#000'
            },
            backcolor: {
                type: String,
                default: '#fff'
            },
            innerPageArticleId: {
                type: String,
                default: '0'
            },
            showNavLine: {
                type: String,
                default: '0'
            },
            showRight: {
                type: String,
                default: '0'
            },
        },
        methods: {
            returnBackFn() {
                this.$emit('returnBack');
            },
            goInsidePages(id){
                this.$emit('goInsidePages', id);
            },
            goRight(){
                this.$emit('goRight');
            },
            getStatusHeight() {
                let statusHeight = this.getCount(this.$store.state.statusheight);

                if (statusHeight === 0) {
                    statusHeight = 20;
                }

                return statusHeight;
            }
        }
    }
</script>

<style scoped>
    .head {
        width: 100%;
        position:fixed;
        z-index: 999;
        background-color: #fff;
    }

    .head .status {
        width: 100%;
        height: 0px;
    }

    .head .left {
        float: left;
        width: 50px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .head .left .icon_black {
        width: 25px;
        height: 22px;
        margin: 0;
    }

    .head .left .icon_white {
        width: 30px;
        height: 30px;
    }

    .head .nav_title {
        display: inline-block;
        height: 44px;
        line-height: 44px;
        font-size: 17px;
        font-weight: bold;
        text-align: center;
        position: absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .action_left {
        margin-right: 15px;
        height: 44px;
        float: right;
    }
    .action_left img {
        width:20px;
        float: left;
        margin-right:3px;
        margin-top: 13px;
    }
    .action_left span {
        float: left;
        line-height: 44px;
        font-size: 15px;
        color: white;
    }

    .action_right {
        margin-top: 7px;
        margin-right: 10px;
        padding-left: 8px;
        padding-right: 8px;
        height: 24px;
        float: right;
        border: 1px solid #ff5050;
        border-radius: 12px;
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        display: flex;
        align-items: center;
    }
    .action_right img {
        display: inline-block;
        vertical-align: middle;
        width:16px;
    }
    .action_right span {
        display: inline-block;
        vertical-align: middle;
        font-size: 13px;
        margin-left: 3px;
        color: #ff5050;
    }
    .nav_line {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 0.5px;
        background-color: #E5E3E3;
    }
</style>
